import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'
export const cn = (...args) => {
  return twMerge(clsx(...args))
}
//This function is used to check if data is primitive or not, to avoid error rendering
export const isPrimitiveDataType = (value) => {
  if (Array.isArray(value)) return false
  if (typeof value === 'object') return false
  return true
}
export const convertToTitle = (str = '') => {
  str = str.replace(/_/g, ' ').replace(/^./, (s) => s.toUpperCase())
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())
}

export const isObject = (value) => {
  if (Array.isArray(value)) return false
  return typeof value === 'object' && value !== null
}

/**
 * 自动生成 SKU (CTYEA Part Number)
 * 前缀为 CTYEA，后跟一个较长的数字（基于时间戳和随机数）
 * @returns {string} 生成的 SKU
 */
export const generateSKU = () => {
  const timestamp = Date.now().toString()
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
  return `CTYEA${timestamp}${random}`
}
